import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Container, SectionTabs as DimSectionTabs } from '@bn-apps/dim-ui-react';
import { useAuth } from '@hooks/useAuth';
import { isInSection, isOnPage, visibleNavigation } from '@config/navigation';
import styles from './SectionTabs.module.scss';

/**
 * Links to the pages in the same menu section, e.g. Search and All tools under Tools.
 * Shown on every page of a section, including the pages below a tab.
 */
export function SectionTabs(): JSX.Element | null {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!user?.isAuthenticated) return null;

  const section = visibleNavigation(user.isProjectMember === true).find((s) => isInSection(pathname, s));
  // A section with one page is a plain link in the menu, so it has no tabs
  if (!section || section.pages.length < 2) return null;

  const tabs = section.pages.map((page) => ({
    label: t(page.labelKey),
    href: page.path,
    isCurrent: pathname === page.path ? ('page' as const) : isOnPage(pathname, page.path) || undefined,
  }));

  return (
    <Container className={styles.sectionTabs}>
      <DimSectionTabs tabs={tabs} sectionLabel={t(section.labelKey)} navigationLabel={t('common.sectionNavigation')} />
    </Container>
  );
}
